export class OtpValidationToken {

    public otp: string = '';
    public userIdStr: string = '';
    public failureCount: string = '';
    public failedAttemptCount: number = 0;
    public companyCode!: string;
}
